import * as React from 'react';
import Modal from "../Modal/Modal"
import withModal from "../Modal/withModal"
import { ModalProps } from "../Modal/types"

type Props = {
    test?: boolean;
} & ModalProps;

class SizeGuide extends React.Component<Props> {

    render() {
        const { toggleModal, isModalOpen } = this.props;
        let bodyHtml = '';
        let sizeGuideDesktop = undefined;
        if (window.innerWidth < 768) {
            sizeGuideDesktop = document.querySelector('#size-guide-mobile');
        } else {
            sizeGuideDesktop = document.querySelector('#size-guide-desktop');
        }
        if (sizeGuideDesktop) {
            bodyHtml = sizeGuideDesktop.innerHTML;
        }
        return (
            <>
                <div className='size-guide__link-wrapper'>
                    <button className='size-guide__link button-style-4' onClick={toggleModal}>Size Guide</button>
                </div>
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={toggleModal}
                    body={bodyHtml}
                />
            </>
        );
    }
}

export default withModal(SizeGuide);
